// @flow

// $FlowFixMe
import * as yup from 'yup';

import { isOtherSelected } from 'Constants/installationAsBuild';

const getOtherText = (parent: Object, fieldName: string): string => {
  const field = parent[fieldName];

  if (typeof field === 'object' && field !== null && field.other != null) {
    return String(field.other).trim();
  }

  return '';
};

export default function radioWithOtherYup(emptyOtherMessage: string) {
  return yup
    .mixed()
    .nullable()
    .required('This field is required')
    .test('radio-with-other', emptyOtherMessage, function validateRadio(value) {
      if (isOtherSelected(value)) {
        return getOtherText(this.parent, this.path).length > 0;
      }

      return value != null && String(value).trim() !== '';
    });
}
